import React, { FC, useEffect } from "react";

type Props = {
  isShow: boolean;
  setShow: any;
  message: string;
  isSeenClose?: boolean;
  isSeenTick?: boolean;
  background?: string;
  text?: string;
  autoHide?: boolean;
  isShowOnMeQR?: boolean
};
export const CustomToast: FC<Props> = ({
  isShow,
  setShow,
  message,
  isSeenClose = true,
  isSeenTick = false,
  background = "bg-dark-gray",
  text = "text-white fw-400",
  autoHide = true,
  isShowOnMeQR = false
}) => {
  const closeToast = () => {
    if(isShow) setShow(false);
  };

  useEffect(() => {
    if (isShow && autoHide) {
      const timer = setTimeout(() => {
        setShow(false);
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [isShow, setShow, autoHide]);

  if(window.self !== window.top && !isShowOnMeQR) return <></>;

  return (
      <div
      className={`customToast toast-zindex position-fixed toast align-items-center ${background} border-0 ${isShow ? "show" : ""}`}
      style={{
        width: "fit-content",
        boxShadow: "none",
        left: "50%",
        transform: "translate(-50%, 0px)"
      }}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="d-flex">
        <div className="toast-body d-flex align-items-center py-2 px-3">
          {isSeenTick && <i className="bi bi-check-lg text-white me-2" style={{fontSize: "16px"}}></i>}
          <p className={`m-0 ${text}`}>
            {message}
          </p>
          {isSeenClose && (
            <button
              type="button"
              className="btn-close btn-close-white ms-2"
              aria-label="Close"
              onClick={closeToast}
              style={{
                fontSize: "11px",
                opacity: "1",
              }}
            ></button>
          )}
        </div>
      </div>
    </div>
  );
};
